module.exports = __webpack_public_path__ + "img/onis-royale.4a22aa43.webp";